<template>
  <div>
    <!--S 右侧区域-->
    <!-- <transition name="slide-right"> -->
    <router-view v-if="viewShow"></router-view>
    <!-- </transition> -->
    <!--E 右侧区域-->
  </div>
</template>
<script>
export default {
  name: "Templent_Order",
  provide() {
    return { reload: this.reload };
  },
  data() {
    return {
      viewShow: true
    };
  },
  filters: {},
  components: {},
  methods: {
    reload: function() {
      this.viewShow = false;
      this.$nextTick(() => {
        this.viewShow = true;
      });
    }
  },
  created() {},
  watch: {},
  mounted() {},
  computed: {}
};
</script>

<style scoped>
@import "Css/Style.css";
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/Templent_Order.vue